import { Github, Mail, Linkedin } from "lucide-react"
import { projects } from "../../portfolio"
import styles from "./StaticHighlights.module.css"

const STACK = [
  "React",
  "TypeScript",
  "Node.js",
  "GraphQL",
  "PostgreSQL",
  "AWS",
  "React Native",
  "NestJS",
]

export function StaticHighlights() {
  return (
    <div id="highlights" className={styles.highlights}>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Stack</h2>
        <div className={styles.tags}>
          {STACK.map((tech) => (
            <span key={tech} className={styles.tag}>
              {tech}
            </span>
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Projects</h2>
        <div className={styles.projects}>
          {projects.map((p) => (
            <a
              key={p.name}
              href={p.sourceCode}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.project}
            >
              <h3 className={styles.projectName}>{p.name}</h3>
              <p className={styles.projectDesc}>{p.description}</p>
              <div className={styles.projectStack}>
                {p.stack.map((t) => (
                  <span key={t} className={styles.projectTag}>
                    {t}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Contact</h2>
        <div className={styles.contact}>
          <a href="mailto:evanking112@gmail.com" className={styles.contactLink}>
            <Mail size={16} />
            evanking112@gmail.com
          </a>
          <a
            href="https://github.com/evank21"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.contactLink}
          >
            <Github size={16} />
            github.com/evank21
          </a>
          <a
            href="https://linkedin.com/in/evanking11"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.contactLink}
          >
            <Linkedin size={16} />
            linkedin.com/in/evanking11
          </a>
        </div>
      </section>
    </div>
  )
}
